import AvatarUser from '../../../../../demand/components/AvatarUser';
import IconButton from '@material-ui/core/IconButton/IconButton';
import Menu from '@material-ui/core/Menu/Menu';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import ChangePasswordDialog from '../ChangePasswordDialog';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import React from 'react';
import styled from 'styled-components';
import connect from 'react-redux/es/connect/connect';
import { onUserLogout } from 'Actions/loginActions';
import ExitToApp from '@material-ui/icons/ExitToApp';
import LockOpen from '@material-ui/icons/LockOpen';
import axios from 'Axios';

const LoggedUser = styled.div`
  display: flex;
  align-items: center;
  position: fixed;
  right: 30px;
  z-index: 1201;
  top: 30px;
`;
const MarginSpan = styled.span`
  margin-left: 5px;
`;

class UserDropdown extends React.Component {
  state = {
    menuOpen: null,
    openPasswordDialog: false,
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    confirmNewPasswordErr: '',
    validateChangingPasswordFormErr: '',
    showCurrent: false,
    showNew: false,
    showConfirm: false,
    disabledButtonPassword: true,
  };

  closePasswordDialog = () => {
    this.setState({
      openPasswordDialog: false,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      confirmNewPasswordErr: '',
      validateChangingPasswordFormErr: '',
      showCurrent: false,
      showNew: false,
      showConfirm: false,
      disabledButtonPassword: true,
    });
  };
  handleClickShowPassword = showPassword => event => {
    this.setState(state => ({ [showPassword]: !state[showPassword] }));
  };

  openPasswordDialog = () => {
    this.setState({ openPasswordDialog: true });
  };

  handleClick = event => {
    this.setState({ menuOpen: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ menuOpen: null });
  };

  handleChangeInput = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  handleBlurValidatePasswordConfirm = inputState => event => {
    if (this.state.newPassword === this.state.confirmPassword) {
      this.setState({
        [inputState]: '',
        disabledBtnEmail: true,
      });
    } else {
      this.setState({
        [inputState]: 'Check your entry, password do not match',
        disabledBtnEmail: true,
      });
    }
  };

  validateChangingPasswordForm = event => {
    if (
      this.state.currentPassword === '' ||
      this.state.newPassword === '' ||
      this.state.confirmPassword === ''
    ) {
      this.setState({
        validateChangingPasswordFormErr:
          'To change your password, you must enter a current password, new password and confirm new password.',
      });
    } else if (this.state.confirmNewPasswordErr === '') {
      this.updatePassword({
        newPassword: this.state.newPassword,
        currentPassword: this.state.currentPassword,
      });
      this.setState({
        validateChangingPasswordFormErr: '',
        disabledButtonPassword: true,
      });
    } else {
      this.setState({
        validateChangingPasswordFormErr:
          'To change your password, you must enter a current password, new password and confirm new password.',
      });
    }
  };

  updatePassword = data => {
    axios
      .post('admin/change_password', {
        oldPassword: this.state.currentPassword,
        newPassword: this.state.newPassword,
      })
      .then(response => {
        if (response.status === 200) {
          this.setState(state => ({
            validateChangingPasswordFormErr: 'Password successfully updated!',
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            confirmNewPasswordErr: '',
            showCurrent: false,
            showNew: false,
            showConfirm: false,
            disabledButtonPassword: false,
          }));
        }
      })
      .catch(err => {
        if (err.response) {
          this.setState({
            validateChangingPasswordFormErr: err.response.data.message.slice(
              27
            ),
            disabledButtonPassword: false,
          });
        }
      });
  };

  render() {
    return (
      <LoggedUser>
        <MenuItem onClick={this.openPasswordDialog}>
          <LockOpen />
          <MarginSpan>Login settings</MarginSpan>
        </MenuItem>
        <MenuItem onClick={this.props.onUserLogout}>
          <ExitToApp /> <MarginSpan settings>Logout</MarginSpan>
        </MenuItem>
        {/*                 
                <AvatarUser user={this.props.user} onClick={this.handleClick} />
                <IconButton
                    aria-label="More"
                    aria-owns={Boolean(this.state.menuOpen) ? 'long-menu' : undefined}
                    aria-haspopup="true"
                    onClick={this.handleClick}
                    className="custom-icon-button"
                >
                    <ArrowDropDown/>
                </IconButton>
                <Menu
                    anchorEl={this.state.menuOpen}
                    id="long-menu"
                    open={Boolean(this.state.menuOpen)}
                    onClose={this.handleClose}
                    PaperProps={{
                        style: {
                            maxHeight: 300,
                            width: 200,
                        },
                    }}
                >
                    <MenuItem onClick={this.props.onUserLogout}>Logout</MenuItem>
                </Menu> */}
        <ChangePasswordDialog
          open={this.state.openPasswordDialog}
          closePasswordDialog={this.closePasswordDialog}
          currentPassword={this.state.currentPassword}
          newPassword={this.state.newPassword}
          confirmPassword={this.state.confirmPassword}
          confirmNewPasswordErr={this.state.confirmNewPasswordErr}
          showNew={this.state.showNew}
          showCurrent={this.state.showCurrent}
          showConfirm={this.state.showConfirm}
          disabledButtonPassword={this.state.disabledButtonPassword}
          handleChangeInput={this.handleChangeInput}
          handleClickShowPassword={this.handleClickShowPassword}
          handleMouseDownPassword={this.handleMouseDownPassword}
          handleBlurValidatePasswordConfirm={
            this.handleBlurValidatePasswordConfirm
          }
          validateChangingPasswordForm={this.validateChangingPasswordForm}
          validateChangingPasswordFormErr={
            this.state.validateChangingPasswordFormErr
          }
        ></ChangePasswordDialog>
      </LoggedUser>
    );
  }
}
export default connect(null, {
  onUserLogout,
})(UserDropdown);
